import React from 'react';
import {LongTextInput, maxLength, required, TextInput} from 'react-admin';
import {Grid} from '@material-ui/core'
import {EPartnerInput} from "./EPartner";


const ParkingPartnerFields = (props) => {
    return (
        <React.Fragment>
            <Grid item xs={12} sm={6}>
                <EPartnerInput source="partner" {...props} validate={[required()]}/>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextInput source="name" {...props} validate={[required(), maxLength(255)]}/>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextInput source="code" {...props} validate={[required(), maxLength(25)]}/>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextInput source="apiUrl" {...props} validate={[maxLength(255)]}/>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextInput source="userName" {...props} validate={[maxLength(50)]}/>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextInput source="password" type="password" {...props} validate={[maxLength(50)]}/>
            </Grid>
            <Grid item xs={12} sm={6}>
                <LongTextInput source="publicKey" {...props} validate={[maxLength(2048)]}/>
            </Grid>
        </React.Fragment>
    )
}
export default ParkingPartnerFields